<template>
  <div class="wechat-advert-container">
    <!-- 搜索区 -->
    <el-card class="search-wrapper">
      <div slot="header" class="clearfix flex justify-between">
        <span>小程序轮播图查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="conditions.mainTitle" placeholder="主标题" clearable />
        </el-col>
        <el-col :span="6">
          <!-- 当前小区只读展示（不再用下拉选择，communityId 由 getCommunityId() 自动注入） -->
          <el-input :value="curCommunityName" readonly placeholder="所属小区">
            <template slot="prepend">所属小区</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-select v-model="conditions.shareFlag" placeholder="类型" clearable>
            <el-option label="本小区专属" value="0" />
            <el-option label="平台共享"    value="1" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="queryAdvert">查询</el-button>
          <el-button @click="resetAdvert">重置</el-button>
          <el-button type="primary" size="small" @click="openAddAdvert">新增轮播图</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 列表 -->
    <el-card class="list-wrapper">
      <el-table v-loading="loading" :data="adverts" border style="width: 100%">
        <el-table-column prop="wechatAdvertId" label="ID" align="center" width="180" />
        <el-table-column label="图片" align="center" width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.imageUrl" style="width:60px;height:40px"
                      :preview-src-list="[scope.row.imageUrl]" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="mainTitle" label="主标题" align="center" />
        <el-table-column prop="subTitle"  label="副标题" align="center" />
        <el-table-column prop="seq"       label="排序" align="center" width="80" />
        <el-table-column label="类型" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.shareFlag === '1' ? 'warning' : 'success'">
              {{ scope.row.shareFlag === '1' ? '平台共享' : '本小区专属' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="communityName" label="所属小区" align="center" />
        <el-table-column prop="createTime"    label="创建时间" align="center" />
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditAdvert(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="openDeleteAdvert(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 50]"
        :page-size.sync="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList" />
    </el-card>

    <add-wechat-advert ref="addAdvert" @success="handleSuccess" />
    <delete-wechat-advert ref="deleteAdvert" @success="handleSuccess" />
  </div>
</template>

<script>
import { listWechatAdverts } from '@/api/admin/wechatAdvertApi'
// 注意：communityId 现在从 main.js 注册的 Vue.prototype.getCommunityId() 取
// 行为与 roomList.vue 第 432 行保持一致
import AddWechatAdvert from '@/components/admin/AddWechatAdvert'
import DeleteWechatAdvert from '@/components/admin/DeleteWechatAdvert'

export default {
  name: 'WechatAdvertManageList',
  components: { AddWechatAdvert, DeleteWechatAdvert },
  data() {
    return {
      loading: false,
      adverts: [],
      // 当前小区名称（只读展示用），从 localStorage 的 hc_currentCommunityInfo 取
      curCommunityName: this.getCommunityName(),
      conditions: {
        mainTitle: '',
        // communityId 不再手动维护，由 getList() 每次查询前自动注入
        shareFlag: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        // 跟 roomList.vue 第 432 行一致：自动从当前登录管理员所在小区取 ID
        const _communityId = this.getCommunityId()
        if (!_communityId || _communityId === '-1') {
          this.$message.warning('当前账号未绑定小区，请先到顶部选择小区')
          this.adverts = []
          this.page.total = 0
          return
        }
        const { data, total } = await listWechatAdverts({
          page: this.page.current,
          row: this.page.size,
          communityId: _communityId,
          ...this.conditions
        })
        this.adverts = data
        this.page.total = total
      } catch (e) {
        this.$message.error('查询失败')
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    queryAdvert() {
      this.page.current = 1
      this.getList()
    },
    resetAdvert() {
      this.conditions = { mainTitle: '', shareFlag: '' }
      // 重置后顺便刷新一下当前小区名（防止管理员在另一个 tab 切换了小区）
      this.curCommunityName = this.getCommunityName()
      this.getList()
    },
    openAddAdvert() {
      // 新增弹窗不再需要传 communityOptions，由弹窗内部用 getCommunityId() 注入
      this.$refs.addAdvert.open(null)
    },
    openEditAdvert(row) {
      // 编辑弹窗不再需要传 communityOptions，communityId 字段透传后端原始值（不改小区归属）
      this.$refs.addAdvert.open(row)
    },
    openDeleteAdvert(row) {
      this.$refs.deleteAdvert.open(row)
    },
    handleSuccess() {
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-advert-container {
  padding: 20px;
  .search-wrapper { margin-bottom: 20px; }
  .list-wrapper .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
